var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _path5, _rect6, _path6, _rect7, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectivePoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 148,
    viewBox: "0 0 289 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.9023,
    y: 63.1348,
    width: 64,
    height: 64,
    rx: 32,
    transform: "rotate(-2 78.9023 63.1348)",
    fill: "#FFC844"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.237 78.0499C109.984 76.0623 112.759 75.9653 113.642 77.8961L116.761 84.7131C117.134 85.5271 117.93 86.0643 118.824 86.1046L126.313 86.4426C128.434 86.5383 129.384 89.1479 127.821 90.5846L122.301 95.6573C121.642 96.2629 121.377 97.1864 121.615 98.0493L123.608 105.276C124.172 107.323 121.984 109.033 120.135 107.99L113.604 104.308C112.825 103.868 111.865 103.902 111.118 104.395L104.86 108.523C103.088 109.693 100.786 108.14 101.206 106.058L102.69 98.7102C102.867 97.8328 102.538 96.9301 101.839 96.3718L95.9786 91.6965C94.3189 90.3724 95.0844 87.7029 97.1936 87.4594L104.641 86.5999C105.53 86.4973 106.287 85.9059 106.602 85.0679L109.237 78.0499Z",
    fill: "#24284E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 17,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFC844"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.071 30.9705C141.785 29.2551 144.215 29.2551 144.928 30.9705L147.447 37.027C147.748 37.7502 148.428 38.2443 149.209 38.3069L155.747 38.831C157.599 38.9795 158.35 41.2905 156.939 42.4991L151.957 46.7665C151.363 47.276 151.103 48.0755 151.285 48.8373L152.807 55.2178C153.238 57.0249 151.272 58.4532 149.686 57.4848L144.088 54.0656C143.42 53.6574 142.579 53.6574 141.911 54.0656L136.313 57.4848C134.728 58.4532 132.762 57.0249 133.193 55.2178L134.715 48.8373C134.897 48.0755 134.637 47.276 134.042 46.7665L129.06 42.4991C127.649 41.2905 128.4 38.9795 130.252 38.831L136.791 38.3069C137.571 38.2443 138.251 37.7502 138.552 37.027L141.071 30.9705Z",
    fill: "#24284E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 165.183,
    y: 11.998,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(5 165.183 11.998)",
    fill: "#FFC844"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.401 25.8735C187.139 24.4621 189.213 24.6436 189.694 26.1616L191.393 31.5214C191.596 32.1613 192.14 32.634 192.802 32.7458L198.346 33.6819C199.916 33.947 200.384 35.9764 199.089 36.903L194.517 40.1747C193.971 40.5653 193.689 41.2285 193.787 41.8926L194.61 47.4545C194.843 49.0298 193.058 50.1025 191.777 49.1572L187.252 45.8194C186.712 45.4209 185.994 45.3581 185.393 45.6567L180.358 48.1581C178.931 48.8666 177.359 47.5001 177.863 45.9893L179.639 40.6548C179.851 40.0178 179.689 39.3158 179.219 38.8363L175.284 34.8203C174.17 33.6829 174.983 31.7657 176.576 31.7773L182.198 31.8181C182.869 31.823 183.487 31.4519 183.798 30.8569L186.401 25.8735Z",
    fill: "#24284E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 187.567,
    y: 56.4512,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(2 187.567 56.4512)",
    fill: "#FFC844"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.177 64.9484C202.619 63.983 204.007 64.0315 204.38 65.0253L205.698 68.5343C205.855 68.9533 206.234 69.249 206.678 69.3004L210.402 69.7301C211.456 69.8518 211.839 71.1866 211.009 71.8486L208.079 74.1863C207.729 74.4654 207.565 74.9168 207.654 75.3555L208.396 79.0296C208.606 80.0702 207.455 80.8467 206.568 80.262L203.44 78.1978C203.066 77.9513 202.586 77.9345 202.196 78.1543L198.931 79.9953C198.007 80.5167 196.912 79.6619 197.195 78.6385L198.191 75.025C198.31 74.5936 198.178 74.1319 197.848 73.829L195.088 71.2927C194.307 70.5743 194.781 69.2695 195.842 69.2217L199.586 69.0527C200.034 69.0325 200.432 68.7639 200.618 68.357L202.177 64.9484Z",
    fill: "#24284E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7764,
    y: 8.28906,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-3 74.7764 8.28906)",
    fill: "#FFC844"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.72 19.0772C98.2537 17.5769 100.334 17.4679 101.021 18.9042L103.449 23.9754C103.739 24.5809 104.343 24.9733 105.014 24.9919L110.635 25.1472C112.227 25.1912 112.973 27.1357 111.819 28.2335L107.747 32.1097C107.26 32.5725 107.074 33.2685 107.264 33.9124L108.853 39.3057C109.303 40.8332 107.684 42.1439 106.284 41.3862L101.339 38.7106C100.748 38.3911 100.029 38.4288 99.4748 38.8082L94.8365 41.9861C93.5229 42.8861 91.7761 41.7517 92.064 40.1856L93.0805 34.6558C93.2019 33.9955 92.9437 33.3229 92.4117 32.9134L87.9561 29.4842C86.6942 28.5129 87.2333 26.5011 88.8117 26.2909L94.385 25.5489C95.0505 25.4603 95.6104 25.0069 95.8354 24.3744L97.72 19.0772Z",
    fill: "#24284E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 43.999,
    y: 44.1836,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-5 43.999 44.1836)",
    fill: "#FFC844"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3049 54.1637C67.7859 52.6457 69.8608 52.4641 70.5981 53.8755L73.2016 58.8589C73.5124 59.4539 74.13 59.825 74.8013 59.8202L80.4236 59.7793C82.016 59.7677 82.8298 61.685 81.7153 62.8224L77.7804 66.8383C77.3105 67.3178 77.1485 68.0199 77.3605 68.6568L79.1368 73.9913C79.6399 75.5022 78.0679 76.8686 76.6418 76.1602L71.6064 73.6588C71.0052 73.3601 70.2874 73.4229 69.7472 73.8214L65.2227 77.1592C63.9413 78.1045 62.1559 77.0318 62.389 75.4566L63.2119 69.8946C63.3102 69.2306 63.0287 68.5673 62.4827 68.1767L57.9101 64.905C56.6151 63.9784 57.0836 61.949 58.6538 61.6839L64.1978 60.7478C64.8597 60.6361 65.4035 60.1634 65.6063 59.5234L67.3049 54.1637Z",
    fill: "#24284E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 141.021,
    y: 64.1152,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(4 141.021 64.1152)",
    fill: "#FFC844"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.055 79.869C166.886 78.2076 169.31 78.3771 169.902 80.138L171.993 86.3555C172.242 87.0979 172.886 87.6382 173.661 87.7551L180.147 88.7341C181.984 89.0114 182.571 91.3692 181.08 92.4764L175.812 96.3859C175.184 96.8527 174.869 97.6321 174.997 98.4047L176.07 104.876C176.374 106.709 174.313 107.996 172.799 106.92L167.453 103.118C166.815 102.664 165.977 102.606 165.281 102.966L159.459 105.987C157.809 106.842 155.948 105.28 156.504 103.508L158.467 97.2488C158.702 96.5016 158.498 95.6859 157.941 95.1362L153.269 90.5317C151.946 89.2276 152.856 86.9746 154.714 86.9557L161.273 86.8889C162.056 86.8809 162.769 86.4355 163.119 85.7351L166.055 79.869Z",
    fill: "#24284E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 90C59 88.8954 59.8954 88 61 88H81.2654C82.2607 88 83.1046 88.7319 83.2453 89.7172L86.7547 114.283C86.8954 115.268 87.7393 116 88.7346 116H189.265C190.261 116 191.105 115.268 191.245 114.283L194.755 89.7172C194.895 88.7319 195.739 88 196.735 88H217C218.105 88 219 88.8954 219 90V116V142C219 143.105 218.105 144 217 144H187H91H61C59.8954 144 59 143.105 59 142V116V90Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250 45L270.5 39",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 29.5L23.5 19.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253.5 88.5L266 93",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3 88.5L18 84.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 124.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.5,
    cy: 64.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 40.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.5,
    cy: 130.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 31 148)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectivePoints);
export default __webpack_public_path__ + "static/media/collective-points.7591944d605ab94233222d5a7cf2bdab.svg";
export { ForwardRef as ReactComponent };